module.exports = __webpack_public_path__ + "img/3.c0cb42b4.jpg";